import React, { useEffect, useState } from 'react';
import moment from 'moment';
import speciesIcon from '../../assets/home/species.png';

import { useSelector } from 'react-redux';
import { daysDropdown } from '../../data';
import { config, getZero, swalWithStyledButton } from '../../utills/constants';
import { useMediaQuery, Grid, Button, Box, Checkbox, Skeleton, FormControlLabel } from '@mui/material';
import { UserName, InstructionsSpan } from '../Elements';
import { Text, FormBox, Edit, TransparentBtn } from './Elements';
import { CustomLabel2 } from '../../components/InputFields/Elements';
import { UnAvailableDays } from '../../components/Modal/UnAvailableDays';
import { DateRangeInput } from '../../components/InputFields/DateRangeInput';
import {
  Input,
  Dropdown,
  EmptyDropdown,
  CustomCheckbox,
  SpeciesDropdown,
} from '../../components/InputFields/CreateTripFormFields';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import { FullTextArea } from '../../components/InputFields/Input';

const Step1 = ({
  handleChange,
  state,
  selectedDayRange,
  setSelectedDayRange,
  setTempSelectedDate,
  tempSelectedDate,
}) => {
  const matches600 = useMediaQuery('(max-width:600px)');
  console.log('selectedDayRange', selectedDayRange);
  const [isChange, setIsChange] = useState(false);
  const [optionLoading, setOptionLoading] = useState(false);
  const navigate = useNavigate()

  const { types, species, states } = useSelector((state) => state.general);
  console.log('types', types);
  const [_state, setState] = useState({
    isEdit: false,
    openUnAvailableDays: false,
    unAvailableDaysText: '',
    speciesData: [],
    typesData: [],
    typeOptionsData: [],
  });

  const _handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleOpenDaysModal = () => {
    if (selectedDayRange?.from !== null || selectedDayRange?.to !== null) {
      _handleChange('openUnAvailableDays', true);
      setSelectedDayRange({ ...selectedDayRange });
    }
  };

  const handleGoBack = () =>{
    swalWithStyledButton
    .fire({
      icon: 'warning',
      allowOutsideClick: false,
      allowEscapeKey: false,
      text: `Are you sure you want to cancel?`,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      showCloseButton: true,
    }).then((result) => {
      if (result.isConfirmed) { 
        navigate(-1)
      }
    })
  }

  useEffect(() => {
    setIsChange(false);
    const filteredSpecies = species?.filter((elm) => elm?.type?.name === state?.tradeType);
    _handleChange('speciesData', filteredSpecies);
    handleChange('species', state?.species);
    setTimeout(() => {
      setIsChange(true);
    }, 500);
  }, [state.tradeType]);
  console.log('state.tradeType', state.tradeType);

  // useEffect(() => {
  //   handleChange('unAvailableDays', {});
  //   // eslint-disable-next-line
  // }, [selectedDayRange]);

  const handleStep = () => {
    if (
      state?.tradeType &&
      state?.locationState &&
      state?.locationCity?.trim() &&
      state?.species &&
      state?.returnActivity?.trim() &&
      state?.durationValue
    ) {
      handleChange('steps', 2);
    }
  };
  const checkValidity = () => {
    if (
      selectedDayRange?.['from'] !== null &&
      state?.tradeType &&
      state?.locationState &&
      state?.locationCity?.trim() &&
      state?.species &&
      state?.returnActivity?.trim() &&
      state?.durationValue
    )
      return true;
    else return false;
  };
  const getUnAvailableDays = () => {
    return state?.unAvailableDays?.dayWeekText + ' ' + state?.unAvailableDays?.excludeDateText;
  };

  const handleDurationValue = (e) => {
    const input = e.target.value;
    if (selectedDayRange?.from == null && selectedDayRange?.to == null) {
      if (/^\d*$/.test(input)) {
        handleChange('durationValue', e.target.value);
      }
    } else if (selectedDayRange?.from != null && selectedDayRange?.to != null) {
      const fromDate = moment(
        selectedDayRange?.from?.year +
          '-' +
          getZero(selectedDayRange?.from?.month) +
          '-' +
          selectedDayRange?.from?.day +
          ' 00:00:00',
        'YYYY-MM-DD HH:mm:ss'
      );
      const toDate = moment(
        selectedDayRange?.to?.year +
          '-' +
          getZero(selectedDayRange?.to?.month) +
          '-' +
          selectedDayRange?.to?.day +
          ' 24:00:00',
        'YYYY-MM-DD HH:mm:ss'
      );
      const diffInDays = toDate.diff(fromDate, 'days');
      const _input = state.durationTitle == 'weeks' ? Number(input) * 7 : input;
      if (_input > diffInDays) {
        // setSelectedDayRange({ from: null, to: null });
        // setTempSelectedDate({from: null, to: null });
        clearTheDate()
        if (/^\d*$/.test(input)) {
          handleChange('durationValue', e.target.value);
        }
      } else {
        if (/^\d*$/.test(input)) {
          handleChange('durationValue', e.target.value);
        }
      }
    }
  };

  const handleDurationTitle = (name, value) => {
    if (selectedDayRange?.from == null && selectedDayRange?.to == null) {
      handleChange('durationTitle', value);
    } else if (selectedDayRange?.from != null && selectedDayRange?.to != null) {
      const fromDate = moment(
        selectedDayRange?.from?.year +
          '-' +
          getZero(selectedDayRange?.from?.month) +
          '-' +
          selectedDayRange?.from?.day +
          ' 00:00:00',
        'YYYY-MM-DD HH:mm:ss'
      );
      const toDate = moment(
        selectedDayRange?.to?.year +
          '-' +
          getZero(selectedDayRange?.to?.month) +
          '-' +
          selectedDayRange?.to?.day +
          ' 24:00:00',
        'YYYY-MM-DD HH:mm:ss'
      );
      const diffInDays = toDate.diff(fromDate, 'days');
      const _input = value == 'weeks' ? Number(state.durationValue) * 7 : state.durationValue;
      if (_input > diffInDays) {
        // setSelectedDayRange({ from: null, to: null });
        // setTempSelectedDate({from: null, to: null });
        clearTheDate()
        handleChange('durationTitle', value);
      } else {
        handleChange('durationTitle', value);
      }
    }
  };

  useEffect(() => {
    const uniqueCategoryNames = [...new Set(species?.map((item) => item?.type?.name))];
    const filteredCategoriesArray = types?.filter((item) =>
      uniqueCategoryNames?.includes(item?.name)
    );
    _handleChange('typesData', filteredCategoriesArray);
  }, []);

  const clearTheDate = () => {
    setSelectedDayRange({
      from: null,
      to: null,
    });
    setTempSelectedDate({
      from: null,
      to: null,
    });
    handleChange('unAvailableDays', {
      dayWeekText: '',
      excludeDateText: '',
      daysOfWeek: [],
      disableDates: [],
      disableDatesText: '',
      repeatEvery: 'weeks',
      repeatEveryNumber: 1,
      disableDatesFormated: [],
      unavailableDaysOfWeek: [],
      allUnavailableDates: [],
      excludeSpecificDates: [],
    });
  };

  const getTradeTypeOptions = async (tradeType) => {
    setOptionLoading(true)
    _handleChange('typeOptionsData', []);
    const typeId = types?.find((el) => el?.name === tradeType)?._id;
    try {
      const response = await api.get(`/tradetypeoptions/list?typeId=${typeId}&status=active`, config);
      const activeOptions = response?.data?.data?.filter((el) => el?.status == 'active');
      _handleChange('typeOptionsData', activeOptions);
    } catch (error) {
      // if (error?.response?.data?.message === 'No records found') {
      //   _handleChange('typeOptionsData', []);
      // }
      console.error('error: ', error);
    } finally{
      setOptionLoading(false)
    }
  };

  useEffect(() => {
    if (state?.tradeType) {
      getTradeTypeOptions(state?.tradeType);
    }
  }, [state?.tradeType]);

  const handleCheckboxChange = (e, option) => {
    const { checked } = e.target;
    const tradeOption = {
      _id: option?._id,
      name: option?.name,
      image: option?.image,
    };

    if (checked) {
      // Add the trade option if it's checked
      handleChange('tradeOptions', [...state.tradeOptions, tradeOption]);
    } else {
      // Remove the trade option if it's unchecked
      const updatedTradeOptions = state.tradeOptions.filter((item) => item.name !== option.name);
      handleChange('tradeOptions', updatedTradeOptions);
    }
  };

  const handleTradeType = (handleFor, value) => {
    handleChange(handleFor, value);
    handleChange('tradeOptions', []);
  };


  return (
    <FormBox sx={{ width: '40%' }}>
      <UserName sx={{ fontSize: '18px' }}>Create New Trip</UserName>
      <Grid container spacing={matches600 ? 0 : 1}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
          <CustomLabel2>I want to trade...</CustomLabel2>
          <Dropdown
            value={state.tradeType}
            placeholder="Example: Central NC Whitetail Hunting"
            data={types}
            handleChange={handleTradeType}
            handleFor="tradeType"
          />
        </Grid>
        {optionLoading ? (
          <Grid item xs={12}>
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
          </Grid>
        ) : (
          _state?.typeOptionsData?.length > 0 && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <CustomLabel2>Using</CustomLabel2>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {_state?.typeOptionsData?.map((option) => {
                  return (
                    <FormControlLabel
                      key={option?._id}
                      control={
                        <Checkbox
                          checked={state?.tradeOptions?.some((el) => el?.name === option?.name)}
                          onChange={(e) => handleCheckboxChange(e, option)}
                        />
                      }
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <img src={option?.image} width="20" height="20" />
                          <CustomLabel2>{option?.name}</CustomLabel2>
                        </Box>
                      }
                    />
                  );
                })}
              </Box>
            </Grid>
          )
        )}

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CustomLabel2>Located in... </CustomLabel2>
          <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={8} lg={7}>
              <Input
                value={state.locationCity}
                placeholder={'Example: Southeastern'}
                onChange={(e) => handleChange('locationCity', e.target.value)}
              />
            </Grid>
            <Grid item xs={4} lg={5}>
              <Dropdown
                value={state.locationState}
                placeholder="State"
                data={states}
                handleChange={handleChange}
                handleFor="locationState"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CustomLabel2>Please enter the species </CustomLabel2>
          {isChange ? (
            <SpeciesDropdown
              value={state.species}
              label="Any species"
              title="Species"
              data={_state.speciesData}
              handleChange={handleChange}
              handleFor="species"
              placeholder="Example: Whitetail Deer"
              icon={speciesIcon}
            />
          ) : (
            <EmptyDropdown placeholder="Example: Whitetail Deer" />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Input
            value={state.returnActivity}
            title="In return for..."
            placeholder="Example: Florida Alligator Hunting"
            onChange={(e) => handleChange('returnActivity', e.target.value)}
          />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} lg={12} sx={{ paddingTop: "0px !important" }}>
                <CustomCheckbox value={state.acceptTradeOffers} handleChange={handleChange} handleFor="acceptTradeOffers" title="Accept other trade offers" />
            </Grid> */}
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CustomLabel2>Trip Duration </CustomLabel2>
          <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={6} sm={6} md={6} lg={2}>
              <Input placeholder={'3'} value={state.durationValue} onChange={handleDurationValue} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3}>
              <Dropdown
                value={state.durationTitle}
                placeholder={'Days'}
                data={daysDropdown}
                handleChange={handleDurationTitle}
                handleFor="durationTitle"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CustomLabel2>Trip Availability </CustomLabel2>
          <InstructionsSpan>Guests will be able to choose between these dates.</InstructionsSpan>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <DateRangeInput
            state={state}
            title=""
            sx={{ width: '100%' }}
            width="100%"
            handleChange={handleChange}
            selectedDayRange={selectedDayRange}
            setSelectedDayRange={setSelectedDayRange}
            setTempSelectedDate={setTempSelectedDate}
            tempSelectedDate={tempSelectedDate}
          />
        </Grid>
        <button className="ClearDates" onClick={clearTheDate}>
          Clear Dates
        </button>
      </Grid>

      {state?.unAvailableDays?.excludeDateText || state?.unAvailableDays?.dayWeekText ? (
        <Text sx={{ textAlign: 'start', mt: 2 }}>
          <CustomLabel2>Unavailable Days</CustomLabel2>
          {getUnAvailableDays()}
          <span
            style={{ marginLeft: 20 }}
            onClick={() => {
              _handleChange('isEdit', true);
              _handleChange('openUnAvailableDays', true);
            }}
          >
            Edit
          </span>
        </Text>
      ) : (
        <>
          {selectedDayRange?.from !== null && selectedDayRange?.to !== null && (
            <Text sx={{ textAlign: 'start', mt: 2 }} onClick={handleOpenDaysModal}>
              <span>Set unavailable days</span>
            </Text>
          )}
        </>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
        <CustomLabel2>Trip Note</CustomLabel2>
        <FullTextArea
          rows={2}
          onChange={(e) => handleChange('tripNotes', e.target.value)}
          placeholder={'Optional'}
          title="Trip Note"
          value={state?.tripNotes}
        />
      </Grid>

      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mt: 2,
          mb: 1,
          justifyContent: 'flex-end',
        }}
      >
        <TransparentBtn sx={{ px: { lg: 4 } }} onClick={handleGoBack}>
          Cancel
        </TransparentBtn>
        <Edit onClick={handleStep} sx={{ opacity: checkValidity() ? 1 : 0.5 }}>
          Next: Add Photos
        </Edit>
      </Grid>
      <UnAvailableDays
        grandState={state}
        open={_state.openUnAvailableDays}
        dateRange={selectedDayRange}
        stateName="openUnAvailableDays"
        parentState={_state}
        handle={_handleChange}
        handleState={handleChange}
      />
    </FormBox>
  );
};
export default Step1;
